import React, { useMemo, useState } from "react";
import { useSiteContext } from "../../../state/SiteContext";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface LabelTermProps {
    label: string,
    children: React.ReactNode,
}

/***
 * A source component that returns the value of a label.
 * 
 * Params:
 *      label: The label to return
 */
export const LabelTerm = React.memo(function LabelTerm({ label, children }: LabelTermProps): React.ReactElement {
    const { siteState } = useSiteContext();

    // Get the label key from the label child
    const labelChild = useMemo(() => findFirstComponentOfType(children, "arg-label"), [children]);
    const [labelKey, setLabelKey] = useState("");

    const labelValue: string = useMemo(() => {
        const usedKey = label || labelKey || "";
        const valueFromLanguages = siteState.site?.languages?.find(lang => lang.code === usedKey)?.label;
        return valueFromLanguages || siteState.site?.labels?.[usedKey] || usedKey || "";
    }, [label, labelKey, siteState]);

    return <>
        {labelValue}
        <TextExtractor onExtractedText={setLabelKey}>
            {labelChild?.props.children}
        </TextExtractor>
    </>;
});